/*
 * File: useNewApptModel.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/29/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Custom hook for creating an appointment model to be used in the patient appointment
 */
import { useState, useEffect } from "react";
import PatientStore from "services/patients/store/PatientStore";
import ProviderOfficeFeeModel from "services/patients/demographics/provider_office_fee/store/ProviderOfficeFeeModel";
import ApptStore from "services/appointments/store/DataStore";
import { useStore } from "utils/useStore";

export const useNewApptModel = () => {
  const [newApptModel, setNewApptModel] = useState(null);
  const apptStore = useStore(ApptStore);
  const providerModel = useStore(ProviderOfficeFeeModel);
  const patient = useStore(PatientStore).patientModel;

  useEffect(() => {
    (async () => {
      await providerModel.getProviderOfficeFeeData();
      const providerId = providerModel.patientProvider.userId;

      if (patient && patient.patientId) {
        apptStore.newAppt.setPatient(patient);
        apptStore.newAppt.setProvider(providerId);
      }

      setNewApptModel(apptStore.newAppt);
    })();
  }, [apptStore, patient, providerModel]);

  return newApptModel;
};
